import { computed, type Ref } from "vue";

export function usePageDrawer<T extends BaseEntity>(
  list: Ref<T[]>,
  selectedId: Ref<string | undefined>,
  next: (nextItem: T) => void,
  prev: (prevItem: T) => void
) {
  const currentIndex = computed(() => {
    return list.value.findIndex((item) => item.id === selectedId?.value) ?? -1;
  });

  const prevDisabled = computed(() => {
    return !list.value[currentIndex.value - 1]?.id;
  });

  const nextDisabled = computed(() => {
    return !list.value[currentIndex.value + 1]?.id;
  });

  const goPrev = () => {
    const prevItem = { ...list.value[currentIndex.value - 1] };

    if (prevItem) {
      prev(prevItem);
    }
  };

  const goNext = () => {
    const nextItem = { ...list.value[currentIndex.value + 1] };
    if (nextItem) {
      next(nextItem);
    }
  };

  return {
    prevDisabled,
    nextDisabled,
    goPrev,
    goNext,
  };
}
